import { render, staticRenderFns } from "./Exclamation.vue?vue&type=template&id=57a8e2ed&"
import script from "./Exclamation.vue?vue&type=script&lang=ts&"
export * from "./Exclamation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports